import { Link, useLocation } from "react-router-dom";
import styles from "../Home/HomePage.module.css";
import logo from "../../assets/Full Logo_Horizontal.png";
import React, { useEffect, useState } from "react";

export default function NavBar() {
  const [profileIncomplete, setProfileIncomplete] = useState(
    localStorage.getItem("profile_incomplete") === "true",
  );
  const { pathname } = useLocation();

  const token = localStorage.getItem("auth_token") || localStorage.getItem("token");

  // ✅ 4-state navbar control:
  // "user" | "userlogin" | "admin" | "public"
  const navState = localStorage.getItem("navbar_state") || "";

  const authed = Boolean(token);

  const isAdmin = authed && navState === "admin";
  const isUser = authed && navState === "user";
  const isUserLogin = !authed && navState === "userlogin";
  const isPublic = navState === "public"; // ✅ public page (no auth, no login/register)
  

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth_token")
    localStorage.removeItem("userEmail");
    localStorage.removeItem("navbar_state");
    localStorage.clear();

    if (isAdmin) {
      window.location.href = "/#/admin/login";
    } else {
      window.location.href = "https://p4power.co.za/";
    }
  };

  useEffect(() => {
    const refreshProfileStatus = () => {
      setProfileIncomplete(
        localStorage.getItem("profile_incomplete") === "true",
      );
    };

    window.addEventListener("profile-status-changed", refreshProfileStatus);

    refreshProfileStatus();

    return () => {
      window.removeEventListener(
        "profile-status-changed",
        refreshProfileStatus,
      );
    };
  }, []);

  return (
    <nav className={styles.navbar}>
      <div className={styles.navInner}>
        {/* BRAND */}
        <div className={styles.navBrand}>
          <img
            src={logo}
            alt="Prepaid Power Provider logo"
            className={styles.navBrandLogo}
          />
          <span className={styles.navBrandName}>P4POWER PORTAL</span>
        </div>

        {/* LEFT LINKS */}
        {isUser && (
          <div className={styles.navLinks}>
            <Link className={styles.linkBtn} to="/meters">
              My Meters
            </Link>
            <Link className={styles.linkBtn} to="/wallets">
              My Wallets
            </Link>
            <Link className={styles.linkBtn} to="/notifications">
              My Notifications
            </Link>
          </div>
        )}

        {/* RIGHT SIDE */}
        <div className={styles.navActions}>
          {isPublic ? null : authed ? (
            <>
              {(isUser || (!isAdmin && navState === "userlogin")) && (
                <Link
                  className={`${styles.secondaryBtn} ${
                    profileIncomplete ? styles.profileWarningBtn : ""
                  }`}
                  to="/profile"
                >
                  Profile
                </Link>
              )}
              <button className={styles.navBtn} onClick={handleLogout}>
                Log out
              </button>
            </>
          ) : (
            <>
              {pathname !== "/" && (
                <Link className={styles.secondaryBtn} to="/#/login">
                  Login
                </Link>
              )}
              {pathname !== "/register" && (
                <Link className={styles.primaryBtn} to="/register">
                  Register
                </Link>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
